// extracted by mini-css-extract-plugin
export var SectionTitle = "b1_gm";
export var active = "b1_gn";